import { useQuery } from '@tanstack/react-query';

import getHelpRequestOperatorStatus from 'Api/host-help-partner/getHelpRequestOperatorStatus';
import getHelpRequestOperatorStatusResponse from './model/response/getHelpRequestOperatorStatusResponse';

const useGetHelpRequestOperatorStatus = (monitoringStatus) => {
  const isEnabled = monitoringStatus?.status === 'CLOCKED_IN_ACTIVE';

  return useQuery({
    queryKey: ['help-request-operator-status'],
    queryFn: async () => {
      const response = await getHelpRequestOperatorStatus();

      const result = getHelpRequestOperatorStatusResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: isEnabled,
  });
};

export default useGetHelpRequestOperatorStatus;
